export const TYPES = {
  TEST: 'TEST',
  CUSTOM: 'CUSTOM',
  WORDPRESS: 'WORDPRESS',
  EMBED: 'EMBED',
  NONE: 'NONE'
} as const
